import { ScholasticYear } from 'src/app/models/scholastic-year.model';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Component } from '@angular/core';

@Component({
  selector: 'app-pcto-form-dialog',
  templateUrl: './pcto-form-dialog.component.html',
  styleUrl: './pcto-form-dialog.component.scss',
})
export class PctoFormDialogComponent {
  errorMessage: string | undefined;
  years: string[] = [
    ScholasticYear.getFromCurrent(-2),
    ScholasticYear.getFromCurrent(-1),
    ScholasticYear.getCurrent(),
    ScholasticYear.getFromCurrent(1),
  ];

  pctoForm = new FormGroup({
    isPctoSicurezza: new FormControl(false, Validators.required),
    anno_scolastico: new FormControl(
      ScholasticYear.getCurrent(),
      Validators.required
    ),
    ente: new FormControl(null, Validators.required),
    ore: new FormControl(null, Validators.required),
    note: new FormControl(null),
    file: new FormControl(null, Validators.required),
    document: new FormControl(null, Validators.required),
  });

  constructor(private _dialogRef: MatDialogRef<PctoFormDialogComponent>) {}

  onFileChange(event: any) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.pctoForm.patchValue({ document: file });
    }
  }

  onConfirm(): void {
    this.errorMessage = undefined;
    if (
      this.pctoForm.get('isPctoSicurezza') == null ||
      this.pctoForm.get('isPctoSicurezza')!.value == null
    ) {
      return;
    }
    const type: 'PCTO' | 'PCTO-SICUREZZA' =
      this.pctoForm.get('isPctoSicurezza')!.value == true
        ? 'PCTO-SICUREZZA'
        : 'PCTO';
    // Controllo se c'è l'anno scolastico
    if (this.pctoForm.get('anno_scolastico')?.value == null) {
      this.errorMessage =
        "Inserisci l'anno scolastico di riferimento del documento PCTO";
      return;
    }
    // Controllo se c'è il numero di ore
    if (type == 'PCTO' && this.pctoForm.get('ore')?.value == null) {
      this.errorMessage = 'Inserisci il numero di ore';
      return;
    }
    // Controllo se c'è l'ente
    if (this.pctoForm.get('ente')?.value == null) {
      this.errorMessage = "Inserisci l'Ente di riferimento del documento PCTO";
      return;
    }
    // Controllo se c'è il file
    if (this.pctoForm.get('document')?.value) {
      const file: any = this.pctoForm.get('document')?.value;
      const anno_scolastico: any = this.pctoForm.get('anno_scolastico')?.value;
      const ore: any = this.pctoForm.get('ore')?.value;
      const ente: any = this.pctoForm.get('ente')?.value;
      const note: any = this.pctoForm.get('note')?.value;
      const formData = new FormData();
      if (type == 'PCTO') formData.append('ore', ore);
      formData.append('ente', ente);
      formData.append('anno_scolastico', anno_scolastico);
      formData.append('documento', file, '' + new Date().getTime());
      if (note != undefined && note != null) formData.append('note', note);
      formData.append('pctoType', type);
      this._dialogRef.close(formData);
    } else {
      this.errorMessage = 'Seleziona il file da salvare';
      return;
    }
    return;
  }

  onDismiss(): void {
    this._dialogRef.close(false);
  }
}
